import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getBilledEventsPath = () => urlHelper('/billed-events');
